import { createFileRoute, redirect } from '@tanstack/react-router';
import { Permission } from '../../features/auth';
import { AssignToCasePage } from '../../features/assign-to-case';

export const Route = createFileRoute('/_auth/assign-to-case')({
  staticData: {
    title: 'pages.assignToCase.title',
    description: 'pages.assignToCase.description',
  },
  beforeLoad: async ({ context }) => {
    const { isAuthenticated, hasPermission, isAdmin } = context.auth;

    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.OR_ASSIGN) && !isAdmin()) throw redirect({ to: '/403' });
  },
  component: AssignToCasePage,
});
